import { Link } from '../lib/router';

export default function PublicHeader({ currentPage }) {
  return (
    <header className="loyal-nav">
      <div className="loyal-nav-brand">
        <Link to="/" aria-label="LoyalQR.sg home">
          <img
            className="loyal-logo"
            src="/logo-v2-wordmark.png"
            width="615"
            height="165"
            alt="LoyalQR.sg"
          />
        </Link>
        <span className="loyal-nav-local">
          <span role="img" aria-label="Singapore flag">
            🇸🇬
          </span>
          <span>Made for Singapore businesses</span>
        </span>
      </div>
      <nav className="loyal-nav-actions" aria-label="Main navigation">
        <Link
          className="loyal-resources-link"
          to="/resources"
          aria-current={currentPage === 'resources' ? 'page' : undefined}
        >
          Resources
        </Link>
        <Link
          className="loyal-contact-link"
          to="/contact"
          aria-current={currentPage === 'contact' ? 'page' : undefined}
        >
          Contact us
        </Link>
        <Link className="loyal-business-login" to="/merchant/login">
          Business login
        </Link>
      </nav>
    </header>
  );
}
